import { Link } from '@tanstack/react-router';
import { useState } from 'react';
import { setRecoveryCodes } from './recovery-store';

/** Shown once, right after the codes are made. They can't be shown again. */
export function RecoveryCodesView({ codes, onDone }: { codes: string[]; onDone: () => void }) {
  const [saved, setSaved] = useState(false);
  const [copied, setCopied] = useState(false);
  const text = codes.join('\n');

  async function copy() {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 2500);
    } catch {
      setCopied(false);
    }
  }

  function download() {
    const blob = new Blob([`Personal OS recovery codes\nEach works once.\n\n${text}\n`], {
      type: 'text/plain',
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'personal-os-recovery-codes.txt';
    a.click();
    URL.revokeObjectURL(url);
  }

  return (
    <div className="recovery" data-testid="recovery-codes">
      <h3 className="card-heading">Your recovery codes</h3>
      <p className="card-detail">
        <strong>Save these now.</strong> They're shown only once. Each code works one time, if you
        lose your phone. Keep them somewhere safe, like a printed page in a drawer.
      </p>
      <ul className="codes">
        {codes.map((code) => (
          <li key={code}>
            <code>{code}</code>
          </li>
        ))}
      </ul>
      <div className="button-row">
        <button type="button" onClick={() => void copy()}>
          {copied ? 'Copied' : 'Copy all'}
        </button>
        <button type="button" onClick={download}>
          Download
        </button>
        <Link to="/account/recovery-codes/print" onClick={() => setRecoveryCodes(codes)}>
          Print page
        </Link>
      </div>
      <label className="check">
        <input type="checkbox" checked={saved} onChange={(e) => setSaved(e.target.checked)} />
        <span>I have saved these codes somewhere safe</span>
      </label>
      <button type="button" className="primary" disabled={!saved} onClick={onDone}>
        Done
      </button>
    </div>
  );
}
